<template>
  <div id="navbar">
    <v-toolbar color="blue" dark>
      <v-toolbar-title>VoIP Inventory Sheet</v-toolbar-title>
      <v-spacer></v-spacer>
      <span v-if="isLoggedIn"><v-btn v-bind:to="{name: 'user', params: {user: currentUser}}" flat>{{currentUser}}</v-btn></span>
      <span v-if="isLoggedIn"><v-btn to="/" flat>Home</v-btn></span>
      <!--<span v-if="isLoggedIn"><v-btn to="/register" flat>Register</v-btn></span>-->
      <span v-if="isLoggedIn"><v-btn v-on:click="logout" flat>Logout</v-btn></span>
    </v-toolbar>
  </div>
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'navbar',
  data() {
    return {
      isLoggedIn: false,
      currentUser: false
    }
  },
  created () {
    if(firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
    }
  },
  methods: {
    logout: function() {
      firebase
      .auth()
      .signOut()
      .then(() => {
        this.$router.go({path: this.$router.path});
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue